import { Fragment } from 'preact'
import { useContext } from 'preact/hooks'
import { AppContext } from '@/js/components/app-context'
import { Icon } from '@/js/components/icon'

export default function PreviewPanel({ item, components, refresh }) {
    const app = useContext(AppContext)

    const titleClasses = {
        10: 'display-1',
        20: 'display-2',
        30: 'display-3',
        40: 'display-4',
    }

    let titleClass = 'h1'
    for (const size of Object.keys(titleClasses)) {
        if (size > item.label.length) {
            titleClass = titleClasses[size]
        }
    }

    async function doAjaxRequest(e, action) {
        e.preventDefault()

        /** @type {ModalManager} */
        const modalManager = app.get('modalManager')
        const { isConfirmed } = await modalManager.confirm('Are you sure to do this action?', 'Confirmation')
        if (isConfirmed) {
            $.ajax({
                url: action.url,
                method: action.method || 'post',
                responseType: 'json',
            }).done((response) => {
                if (response?.success?.message) {
                    modalManager.toast('success', response.success.message)
                    refresh()
                }
            })
        }
    }

    return (
        <section className={`py-2 px-0 p-lg-4 p-xl-5 overflow-auto ${item.theme}`}>
            <h1 className="text-center display-4">
                <span className="avatar avatar-2xl">
                    <Icon name={item.icon_url ?? item.icon} />
                </span>
            </h1>
            <h1 className={`text-center text-uppercase ${titleClass}`}>
                <components.Highlight hit={item} attribute="label" />
            </h1>

            {item.htmlDescription && <div dangerouslySetInnerHTML={{ __html: item.htmlDescription }} />}

            {Object.values(item.urls).length > 0 && (
                <Fragment>
                    <h2 className="mt-4">Quick actions</h2>
                    <div className="card">
                        <div className="list-group">
                            {Object.values(item.urls).map((action, index) => {
                                if (action.ajax) {
                                    return (
                                        <a
                                            // biome-ignore lint/suspicious/noArrayIndexKey: Using index as key is acceptable here because the list is static and does not change order
                                            key={index}
                                            className="list-group-item list-group-item-action d-flex align-items-center"
                                            href="#"
                                            onClick={(e) => doAjaxRequest(e, action)}
                                        >
                                            <Icon name={action.icon} className={action.iconClass || 'text-secondary'} />
                                            <span className="ms-1">{action.label}</span>
                                        </a>
                                    )
                                }

                                return (
                                    <a
                                        // biome-ignore lint/suspicious/noArrayIndexKey: Using index as key is acceptable here because the list is static and does not change order
                                        key={index}
                                        className="list-group-item list-group-item-action d-flex align-items-center"
                                        href={action.url}
                                        target="_blank"
                                        rel="noreferrer"
                                    >
                                        <Icon name={action.icon} className={action.iconClass || 'text-secondary'} />
                                        <span className="ms-1">{action.label}</span>
                                    </a>
                                )
                            })}
                        </div>
                    </div>
                </Fragment>
            )}
        </section>
    )
}
